<template>
  <el-upload
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="正在上传"
    :show-file-list="!slotShow"
    :list-type="listType"
    :action= "action"
    :drag= "drag"
    :data= "fileData"
    :accept= "accept"
    :before-upload= "beforeUpload"
    :on-success = "onSuccess"
    :on-error="onError"
    :on-remove= "onRemove"
    :limit= "limit"
    :file-list= "fileList">
    <slot v-if="slotShow"></slot>
    <el-button v-else size="small" type="primary">点击上传</el-button>
  </el-upload>
</template>

<script>
import { fileDns, bucket } from './config'
import { getUUID } from '@/utils/formatData'
// 附件上传，前后端对接：
// 传送对象或者对象数组，所有参数前端写死传给后端
// 文件名称,eg: 'XXX.txt'
// fileName：string；
// 对应文件链接后缀，即七牛上传及返回的key值，生成规则：年月日+uuid；eg：‘20201010/uuid’
// fileUrl: string;
// 文件前缀,根据姚哥配置的七牛空间名称和类型对应的下载访问前缀，前端根据配置判断写死
// filePrefix :string;
export default {
  name: 'UploadFile',
  props: {
    // 上传文件类型限制
    accept: {
      type: String,
      default: 'image/jpeg,image/jpg,image/png'
    },
    // 最大上传个数
    limit: {
      type: Number,
      default: 6
    },
    // 最大上传大小MB
    maxSize: {
      type: Number, // 单位MB
      default: 100
    },
    // 是否自定义上传样式,为真时不显示element默认文件列表
    slotShow: {
      type: Boolean,
      default: true
    },
    // 文件列表类型同element list-type
    listType: {
      type: String,
      default: 'picture-card'
    },
    // 是否启用拖拽上传
    drag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      action: this.$apis.common.uploadQiniup,
      fileInfo: {
        fileName: '',
        filePrefix: '',
        fileUrl: ''
      },
      fileList: [],
      fileData: {
        token: '',
        key: ''
      },
      fullscreenLoading: false
    }
  },
  created () {
    this.getToken()
  },
  methods: {
    // 空间名：testipark，对应的下载链接http://test.qxt.cdn.gintell.cn + '/' + key
    getToken () {
      this.$axios.get(this.$apis.common.uploadToken, { bucket }).then(res => {
        this.fileData.token = res
        this.getKey()
      })
    },
    // 获取key 年/月/日/uuid
    getKey () {
      const date = new Date()
      this.fileData.key = `${date.getFullYear()}${(date.getMonth() + 1)}${date.getDate()}/${getUUID()}`
    },
    // 上传之前
    beforeUpload (file) {
      const size = file.size / 1024 / 1024 < this.maxSize
      console.log(this.accept)
      const str = this.accept ? this.accept.toLowerCase() : ''
      const name = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      if (str && str.indexOf(name) === -1) {
        this.$message.warning(`上传文件只能是${this.accept}格式!`)
        return false
      } else if (!size) {
        this.$message.warning(`上传文件大小不能超过${this.maxSize}MB!`)
        return false
      } else {
        this.fullscreenLoading = true
      }
    },
    onSuccess (res, file) {
      // 更新key
      this.getKey()
      this.fileInfo = {
        fileName: file.name,
        filePrefix: fileDns,
        fileUrl: res.key
      }
      this.$emit('onSuccess', this.fileInfo)
      this.fullscreenLoading = false
    },
    onError (error) {
      this.fullscreenLoading = false
      this.$message.error(JSON.parse(error.message).message ? JSON.parse(error.message).message : '上传失败')
    },
    onRemove (file) {
      // key 对应 fileUrl
      file.response && this.$emit('onRemove', file.response.key)
    }
  }
}
</script>

<style scoped lang="scss">
  .hide {
    ::v-deep .el-upload {
      display: none;
    }
  }
  ::v-deep {
    .el-upload-list__item {
      transition: none !important;
    }
    .el-upload-list__item.is-ready {
      display: none;
    }
    .el-upload__tip {
      color: #999999;
    }
    //上传图片及图片展示大小调整
    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      border-radius: 0px;
      width: 104px;
      height: 104px;
      line-height: 104px;
      .global-picture-card {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }
      .el-upload-list__item-thumbnail {
        object-fit: fill;
      }
    }
  }
  .import-content {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    .name {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-bottom: 20px;
    }

  .upload-cad {
    width: 400px;
    height: 170px;
    background: #FBFBFB;
    border-radius: 10px;
    border: 1px dashed #C3C3C3;

    ::v-deep {
      .el-upload {
        width: 100%;
        height: 100%;
      }

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        background: transparent;
        border: 0;
      }
    }

    .el-upload__tip {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      text-align: center;
      margin-top: 16px;
    }

    .upload-uploading {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .quan1 {
        width: 270px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 10px;
        border: 1px solid #D6D6D6;

        .quan2 {
          height: 18px;
          background: linear-gradient(-90deg, #01E9BD, #007CDE);
          border-radius: 10px;
          transition: .7s;
        }
      }

      .tips {
        width: 177px;
        height: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        margin-top: 26px;
      }
    }
  }

  .upload-hascad {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    span {
      &:nth-child(1) {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }

      &:nth-child(2) {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #DE0000;
        margin-top: 19px;
      }
    }
  }

  .upload-contnet {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      margin-bottom: 20px;
    }

    span {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}
</style>
